import React from "react";
import Center from "../../../../widget/common/ui/Center";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import AppTheme from "../../../../service/app_config/AppTheme";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { textCase } from "../../../../service/ui/UI";

type BranchListDivisionSwitchProps = {
  title: string;
  switchDivision: () => void;
};

const BranchListDivisionSwitch: React.FC<BranchListDivisionSwitchProps> = ({
  title,
  switchDivision,
}) => {
  const type: number = ResponsiveDeviceType();

  return (
    <Center className="pb-3">
      <div role="button" className="d-center" onClick={switchDivision}>
        <TextBlock className="pe-3" fontSize="16_17" fontName="bold">
          {textCase(title)}
        </TextBlock>
        <IconCircleFilledIcon
          name="swicth2"
          size={type === 1 ? 27 : 39}
          color={AppTheme.themeFont}
        />
      </div>
    </Center>
  );
};

export default BranchListDivisionSwitch;
